import {useTranslation} from "react-i18next";
import Tooltip from "../../Shared/Tooltip";
import { twMerge } from "tailwind-merge";

interface DataGridNoRowsOverlayProps extends React.HTMLAttributes<HTMLDivElement> {
    filtered: boolean;
}

export default function DataGridNoRowsOverlay({ filtered, className, ...props }: DataGridNoRowsOverlayProps) {
    const { t } = useTranslation();

    return (
        <div {...props} className={twMerge('rounded-[0.4rem] border-[1px] border-[#e5e7eb]', className)} >
            <div className='h-[64px] rounded-t-[0.4rem] bg-[#F4F8FB] border-b-[1px] border-[#e5e7eb]'></div>
            <div className={'bg-white rounded-b-[0.4rem] flex items-center justify-center h-[200px] text-xl gap-2'}>
                {t('datagrid:noData')}
                <Tooltip text={filtered ? t('datagrid:noDataFoundFiltered') : t('datagrid:noDataFound')} />
            </div>
        </div>
    );
}
